import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import Pagination from "@mui/material/Pagination";
import { formatarValor } from "../../../components/OrderTable";
import CustomButton from "../../../components/CustomButton";
import { formatDate } from "../../../components/TableAddPayments"; // Supondo que você tenha essa utilidade
import DeleteButton from "../../../components/DeleteButton";

const SimulationsList = () => {
  const [simulations, setSimulations] = useState([]);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const simulationsPerPage = 10;
  const year = new Date().getFullYear();
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchSimulations = async () => {
      try {
        setIsLoading(true);
        const response = await api.get("/simulations");
        setSimulations(response.data);
      } catch (error) {
        console.error("Erro ao buscar simulações:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchSimulations();
  }, []);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleDeleteSimulation = async (id) => {
    try {
      setErrorMessage("");
      await api.delete(`/simulations/${id}`);
      setSimulations((prevState) => prevState.filter((item) => item.id !== id));
    } catch (error) {
      console.error("Erro ao excluir simulação: ", error);
      setErrorMessage("Não foi possível excluir a simulação");
    }
  };

  const totalPages = Math.ceil(simulations.length / simulationsPerPage);
  const indexOfLastSimulation = currentPage * simulationsPerPage;
  const indexOfFirstSimulation = indexOfLastSimulation - simulationsPerPage;
  const currentSimulations = simulations.slice(
    indexOfFirstSimulation,
    indexOfLastSimulation
  );

  const handleCreateNew = () => {
    navigate("/simulacoes/nova-simulacao");
  };

  if (isLoading) return <p>Carregando...</p>;

  return (
    <div className="p-4">
      <div className="flex justify-between h-[40px] my-2">
        <div className="w-[210px]">
          <CustomButton
            onClick={handleCreateNew}
            className="bg-primary text-white font-semibold"
          >
            Nova Simulação
          </CustomButton>
        </div>
      </div>

      <div className="overflow-x-auto ">
        <table className="w-full border-collapse ">
          <thead>
            <tr className="bg-gray-100 text-center h-[45px]">
              <th className="px-4 font-semibold text-[14px] text-[#2F2E41]">
                Nome
              </th>
              <th className="px-4 font-semibold text-[14px] text-[#2F2E41]">
                Data
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {currentSimulations.map((simulation) => (
              <tr
                key={simulation.id}
                className="h-[49px] border-b text-center border-[#D5D5D5] hover:bg-gray-50"
              >
                <td
                  className="px-4 text-[#2F2E41] hover:cursor-pointer"
                  onClick={() => navigate(`/simulacao/${simulation.id}`)}
                >
                  {simulation.name || ` P00${simulation.id}-${year}`}
                </td>

                <td
                  className="px-4 text-[#2F2E41] hover:cursor-pointer"
                  onClick={() => navigate(`/simulacao/${simulation.id}`)}
                >
                  {formatDate(simulation.createdAt)}
                </td>

                <td className="px-4 text-right">
                  <DeleteButton
                    onConfirm={() => {
                      handleDeleteSimulation(simulation.id);
                    }}
                    errorMessage={errorMessage}
                    setErrorMessage={setErrorMessage}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {simulations.length === 0 && (
        <div className="text-center py-8 text-gray-500">
          Nenhuma simulação encontrada
        </div>
      )}

      <Pagination
        className="mt-4 flex justify-end"
        count={totalPages}
        onChange={(_, page) => handlePageChange(page)}
        sx={{
          "& .MuiPaginationItem-root": {
            color: "#2F2E41",
            borderRadius: 0,
            minWidth: "20px",
            height: "20px",
            margin: "0 2px",
          },
          "& .MuiPaginationItem-root.Mui-selected": {
            color: "#FF9935",
            backgroundColor: "transparent",
          },
          "& .MuiPaginationItem-icon": {
            color: "#FF9935",
          },
          "& .MuiPaginationItem-root.Mui-disabled .MuiPaginationItem-icon": {
            color: "#D3D3D3",
          },
        }}
      />
    </div>
  );
};

export default SimulationsList;
